<template>
    <div class="columns settings is-multiline">
        <div class="column is-12">
            <div class="box">
                <h1 class="title"><i class="fa fa-cog"></i> Inställningar</h1>
            </div>
        </div>
        <div class="column is-12" v-if="models">
            <div class="box">
                <div class="columns">
                    <div class="column is-3">
                        <b>Inställning</b>
                    </div>
                    <div class="column is-3">
                        <b>Värde</b>
                    </div>
                </div>
                <div class="columns" v-for="(model, key) in settings" :key="key">
                    <div class="column is-3">
                        {{model.key}}
                    </div>
                    <div class="column is-6">
                        <textarea v-model="model.value"></textarea>
                    </div>
                </div>
                <div class="columns">
                    <div class="column is-12">
                        <a class="button button-primary" @click="updateSettings">Uppdatera</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
    textarea {
        width: 100%;
    }
</style>

<script>
import modelMixin from '../mixins/model'

export default {
  name: 'Settings',
  mixins: [modelMixin],
  data () {
    return {
      settings: null
    }
  },
  watch: {
    models: {
      handler: function (newVal, oldVal) {
        if (newVal.name === 'Settings') {
          this.data = newVal
        }
      },
      deep: true
    }
  },
  methods: {
    updateSettings: function () {
      console.log('Printar data', this.settings)
      this.$store.dispatch('updateSettings', { data: this.settings })
        .then((response) => {
        })
        .catch((error) => {
          console.log(error)
        })
    }
  },
  computed: {},
  mounted () {
    console.log(this.models)
    this.settings = this.models
  }
}
</script>
